import { whatsappUrl } from "@/mocks/serra";

export default function CtaBand() {
  return (
    <section
      className="relative py-28 lg:py-36 overflow-hidden"
      style={{
        background:
          "radial-gradient(120% 140% at 50% 0%, #213B5C 0%, #081624 60%)",
      }}
    >
      <div className="absolute inset-0 tech-grid opacity-40"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[36rem] h-[20rem] bg-orange/15 rounded-full blur-3xl"></div>

      <div className="relative max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <h2 className="text-white text-4xl lg:text-6xl font-bold leading-tight mb-8">
          Vamos posicionar sua empresa entre{" "}
          <span className="text-orange">as melhores do mercado</span>?
        </h2>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 font-medium rounded-full bg-orange hover:bg-coral text-bg px-9 py-4 text-base transition-colors duration-300 cursor-pointer whitespace-nowrap"
        >
          Falar com um especialista
        </a>
      </div>
    </section>
  );
}
